import React, { createContext, useContext, useState, useMemo } from 'react';
import LoadingSpinner from '../components/LoadingSpinner/LoadingSpinner';

const LoadingContext = createContext();

export function LoadingProvider({ children }) {
  const [isLoading, setIsLoading] = useState(false);

  const value = useMemo(() => ({
    isLoading,
    setIsLoading,
    showLoading: () => setIsLoading(true),
    hideLoading: () => setIsLoading(false)
  }), [isLoading]);

  return (
    <LoadingContext.Provider value={value}>
      {children}
      {isLoading && <LoadingSpinner />}
    </LoadingContext.Provider>
  );
}

export function useLoading() {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
} 